import React from "react";
import { Avatar } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'

const UserAvatar = (props) => {
  const { size } = props;

  return (
    <Avatar
      data-testid="userAvatar"
      icon={<FontAwesomeIcon icon={faUser} />}
      size={size}
      className="userAvatar"
    />
  );
};

UserAvatar.propTypes = {
  size: PropTypes.string,
};

UserAvatar.defaultProps = {
  size: "medium",
};

export default UserAvatar;
